// extracted by mini-css-extract-plugin
module.exports = {"receiptBlock":"ReceiptBlock_receiptBlock__3fHlG","title":"ReceiptBlock_title__27WnW","orderDetails":"ReceiptBlock_orderDetails__1bfah"};